import { useEffect, useState } from 'react';

/**
 * A seconds counter that ticks itself down to zero — the "you can send a new code in Ns" lock on
 * every OTP resend button.
 *
 * Extracted because the same effect was written out three times (the sign-in challenge, the
 * security page's email enrolment and the SMS one) and a fourth channel would have made it four.
 * The interval is armed only while the counter is above zero, so an idle screen holds no timer.
 */
export function useResendCooldown(): {
  /** Seconds remaining; `0` means the action is available. */
  cooldown: number;
  /** Start (or restart) the lock. */
  startCooldown: (seconds: number) => void;
  /** Release it early — e.g. the user switched to a different delivery channel. */
  clearCooldown: () => void;
} {
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return;
    const tick = window.setInterval(() => setCooldown((s) => (s <= 1 ? 0 : s - 1)), 1000);
    return () => window.clearInterval(tick);
  }, [cooldown]);

  return {
    cooldown,
    startCooldown: setCooldown,
    clearCooldown: () => setCooldown(0),
  };
}
